import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Icon } from 'components';
import { ComponentRegistry } from 'core/index';
import { Tag } from 'legacyComponents/styled/lib';
import { media } from 'legacyComponents/styled/styleUtils';

export const TagItem = observer(({ deleteHandler, fieldStore, item }) => {
  const { prefix } = fieldStore;
  const itemName = item.name;
  const deleteKey = `${itemName}-delete`;
  const deleteButton = (
    <IconStyled
      name='close'
      size='8px'
      onClick={() => deleteHandler(item)}
      key={deleteKey}
    />
  );
  return (
    <ItemTag key={itemName} profile='true'>
      {prefix}
      {itemName} {deleteButton}
    </ItemTag>
  );
});

const IconStyled = styled(Icon)`
  margin-left: 10px;
  vertical-align: baseline;
  color: ${props => props.theme.color.wfOrange};
  &:hover {
    transform: scale(1.3);
  }
`;

const ItemTag = styled(Tag)`
  margin-bottom: 10px;
  display: inline-block;
  ${media.s`
    font-size: 0.7rem;
  `};
`;

ComponentRegistry.add('tags.itemComponent', TagItem);
